module.exports = __webpack_public_path__ + "static/adjust-scale-image-729e9126dffb3add5533bf977c0b3600.svg";